// extracted by mini-css-extract-plugin
export var slide_text = "styles-module--slide_text--3PCqu";
export var slide_info = "styles-module--slide_info--2b9Zf";
export var slide_info_author = "styles-module--slide_info_author--mX-yQ";